// extracted by mini-css-extract-plugin
module.exports = {"container":"_10RCRXh7PZSife_zfE0gI2"};